<template>
  <require from="controls/bs-form-input"></require>
  <require from="controls/as-form-widget.html"></require>

  <div class="wg-related-traveler">
    <as-form-widget icon="far fa-user">
      <div slot="default">
        <div class="form-row">
          <div class="col-sm-6">
            <bs-form-input type="text" label="Traveller #${travelerNumber}" placeholder="Enter name" value.bind="model.name & validate" disabled.bind="controller.disabled" maxlength="500"></bs-form-input>
          </div>
          <div class="col-sm-6">
            <bs-form-input type="text" label="Traveller #${travelerNumber} relation" placeholder="Enter relation" value.bind="model.relation & validate" disabled.bind="controller.disabled" maxlength="100"></bs-form-input>
          </div>
        </div>
      </div>
    </as-form-widget>
  </div>
</template>
